import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createNotification = (params) => {
  return Api(endPoints.createNotification, params, requestType.POST);
};

const getAllNotification = (title) => {
  return Api(
    `${endPoints.getAllNotification}?title=${title}&relatedTo=pushed`,
    null,
    requestType.GET
  );
};

const getUserNotification = (id, notificationRelatedTo) => {
  return Api(
    `${endPoints.getUserNotification}?userId=${id}&userType=admin&notificationRelatedTo=${notificationRelatedTo}`,
    null,
    requestType.GET
  );
};

const markNotificationRead = (id) => {
  return Api(`${endPoints.markReadNotification}/${id}`, null, requestType.PUT);
};

export {
  createNotification,
  getAllNotification,
  getUserNotification,
  markNotificationRead,
};
